import { render } from "./DeleteOption.vue?vue&type=template&id=b2dbed30"
import script from "./DeleteOption.vue?vue&type=script&lang=js"
export * from "./DeleteOption.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__